import { contentClient, Server } from '@wajeez-web/core/api-base';
import { thunkErrorHandler } from '@wajeez-web/core/utils';
import { ApiMethod } from '@wajeez-web/stores/base';

export const getContentEntityStructuresLookups: ApiMethod<
  { languageId?: string },
  Server.ContentEntityStructureOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityStructures_Client(
        undefined,
        contentClient
      );

      const response = await client.contentEntityStructures_get_V1(
        data.languageId
      );

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};
